exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".label[data-v-c24b8fbc]{width:80px}.flex[data-v-c24b8fbc]{-webkit-box-align:center;-ms-flex-align:center;align-items:center}.el-tag[data-v-c24b8fbc]{margin-top:3px}\n", ""]);

// exports
